import {StyledColorBlock} from '@/pages/styles';
import breakpoints from '@/theme/constants/breakpoints';
import {sizePx} from '@/theme/helpers/size';
import Image from 'next/image';
import styled from 'styled-components';
import {StyledBrandImageProps} from './typings';

const customHeight = {
  fastCompany: sizePx(11),
  bloomberg: sizePx(14),
};

export const StyledFeaturedInSection = styled(StyledColorBlock)`
  display: none;

  @media only screen and ${breakpoints.device.l} {
    display: flex;
  }
`;

export const StyledImageContainer = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledBrandImage = styled(Image)<StyledBrandImageProps>`
  width: 100%;
  height: ${(props) => customHeight[props.$id] ?? sizePx(20)};
`;
